/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Billing_AdjustInputs */

const en_settings_billing_adjust = /** @type {(inputs: Settings_Billing_AdjustInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change plan`)
};

const zh_settings_billing_adjust = /** @type {(inputs: Settings_Billing_AdjustInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`调整套餐`)
};

/**
* | output |
* | --- |
* | "Change plan" |
*
* @param {Settings_Billing_AdjustInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_billing_adjust = /** @type {((inputs?: Settings_Billing_AdjustInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Billing_AdjustInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_billing_adjust(inputs)
	return zh_settings_billing_adjust(inputs)
});
export { settings_billing_adjust as "settings.billing.adjust" }